import { gql } from "@apollo/client";

export const GET_DISFAGIA_RESUMEN = gql`
    query DisfagiaRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        disfagiaRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            disfagiaRI{
                videodeglucion
                dIDisfagiaARI{
                    idComboRIValorNavigation{
                        valor
                    }
                }
                episodiosNeumonia
                dIAlimentacionActualRI{
                    idComboRIValorNavigation{
                        valor
                    }
                }
                dIHidratacionActualRI{
                    idComboRIValorNavigation{
                        valor
                    }
                }
                traqueostomia
                lucido
                compromisoMotor
                idComboRIValorKarnofskyNavigation{
                    valor
                }
                actividadMotoraAlAlimentarse
                controlCefalico
                justificacionNadaPorBoca
                nadaPorBoca
                idComboRIValorControlPosturalNavigation{
                    valor
                }
                idComboRIValorDenticionNavigation{
                    valor
                }
                idComboRIValorProtesisNavigation{
                    valor
                }
                idComboRIValorEvaluacionFonoaudiologicaNavigation{
                    valor
                }
                idComboRIValorModuloDisfagiaNavigation{
                    valor
                }
                idComboRIValorNadaPorBocaNavigation{
                    valor
                }
                idComboRIValorHidratacionNavigation{
                    valor
                }
                idComboRIValorLiquidosEspesadosConConsistenciaNavigation{
                    valor
                }
                requiereNutricionEnteral
            }
            videodeglucionAdjunto{
                contentType 
                titulo
                archivo
                extension
            }
        }
    }
`;